import { EquipmentCategory, TEquipmentCategoryId } from '/src/lib/models';

export type TEquipmentTypeId = number;

export type EquipmentByCategory = {
  category_id: TEquipmentCategoryId;
  category_name: string;
  num_equipment: number;
};

export interface EquipmentType {
  id: TEquipmentTypeId;
  name: string;
  equipment_category_id: TEquipmentCategoryId;
  uses_alternate_exd_displaced_formula: boolean;
  equipment_category?: EquipmentCategory;
}

export enum EquipmentTypeId {
  PRE_2011_ELECTRIC_FORKLIFT = 14,
  POST_2010_ELECTRIC_FORKLIFT = 15,
  POST_2022_FIXED_GUIDEWAY_LIGHT_RAIL = 82,
  PRE_2023_FIXED_GUIDEWAY_LIGHT_RAIL = 83,
}

export const hiddenEquipmentTypes: Set<number> = new Set([
  EquipmentTypeId.POST_2010_ELECTRIC_FORKLIFT,
  EquipmentTypeId.PRE_2011_ELECTRIC_FORKLIFT,
  EquipmentTypeId.POST_2022_FIXED_GUIDEWAY_LIGHT_RAIL,
  EquipmentTypeId.PRE_2023_FIXED_GUIDEWAY_LIGHT_RAIL,
]);
